<template>
  <div class="">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="formRef"
        label-width="125px"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="type == '1' ? '扣减金额（元）' : '增加金额（元）'"
          prop="amount"
        >
          <el-input size="small" v-model="ruleForm.amount"></el-input>
          <!-- <div style="font-size: 12px;color: #8c8c8c;">最大可操作额度为{{ useAmount }}元</div> -->
        </el-form-item>
        <el-form-item label="操作原因" prop="remark">
          <el-input
            placeholder="请输入至少五个字符"
            type="textarea"
            v-model="ruleForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :disabled="!useAmount"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { manualUpdate } from "@/api/gift";
export default {
  props: {},
  data() {
    var validateMoney = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入金额"));
      } else {
        const reg = /^[0-9]+([.]{1}[0-9]{1,2})?$/;
        if (!reg.test(value)) {
          callback(new Error("请输入数字，且支持两位小数"));
        }
        if (value > this.useAmount) {
          callback(new Error(`最大可操作额度为${this.useAmount}元`));
          this.ruleForm.amount = this.useAmount;
        } else {
          callback();
        }
      }
    };
    return {
      useAmount: 500000,
      title: "提示",
      type: "1",
      dialogVisible: false,
      ruleForm: {
        amount: "",
        remark: "",
        type: "1",
      },
      rules: {
        amount: [{ required: true, validator: validateMoney, trigger: "blur" }],
        remark: [
          { required: true, message: "请输入操作原因", trigger: "blur" },
          {
            min: 5,
            max: 200,
            message: "长度在 5 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    open(title, type) {
      this.title = title;
      this.type = type;
      this.ruleForm.type = type;
      this.dialogVisible = true;
      if (this.title == "保证金扣减") {
        // console.log(this.$parent.useAmount)
        this.useAmount = this.$parent.useAmount || 0;
      } else if (this.title == "余额扣减") {
        this.useAmount = this.$parent.balanceAvailable || 0;
      } else {
        this.useAmount = 500000;
      }
    },
    handleClose() {
      this.$refs["formRef"].resetFields();
      this.dialogVisible = false;
    },
    submit() {
      if (!this.useAmount) {
        this.$message.error("最大可操作额度为0元");
        return;
      }
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.$emit("submit", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
